try {
// Mobile: hide the header while scrolling down, show it again on any scroll up
(function(){
  var h = document.querySelector('header.site'), mq = matchMedia('(max-width:860px)');
  if (!h) return;
  var last = window.scrollY, ticking = false, MIN = 6;
  function update(){
    ticking = false;
    var y = Math.max(0, window.scrollY), d = y - last;
    // always visible near the top, on desktop, or while the menu is open
    if (!mq.matches || y < h.offsetHeight || document.body.classList.contains('nav-open')) { h.classList.remove('is-hidden'); last = y; return; }
    if (Math.abs(d) < MIN) return;               // ignore jitter / momentum noise
    h.classList.toggle('is-hidden', d > 0);
    last = y;
  }
  window.addEventListener('scroll', function(){ if (!ticking) { ticking = true; requestAnimationFrame(update); } }, {passive: true});
  mq.addEventListener('change', update);
})();
} catch (e) { console.error("lys-v4 header-reveal", e); }
